import { render, staticRenderFns } from "./BarCardDashboard.vue?vue&type=template&id=19e57225&"
import script from "./BarCardDashboard.vue?vue&type=script&lang=js&"
export * from "./BarCardDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports